export default __webpack_public_path__ + "static/media/logo.08c4b904.svg";